import FormInjectValidator from '@common/mixins/FormInjectValidator'

export default {
  mixins: [FormInjectValidator],

  props: {
    value: {
      required: true
    },
    parameters: {
      type: Object,
      default: () => ({})
    },
    labelStyle: {
      type: Object
    },
    errorStyle: {
      type: Object
    }
  },

  data () {
    return {
      fieldValue: this.value
    }
  },

  watch: {
    value: function (newVal) {
      this.fieldValue = newVal
    },

    fieldValue: function (newVal) {
      this.$emit('input', newVal)
    }
  },

  computed: {
    formFieldsErrorStyle () {
      return {
        position: 'relative',
        top: '-3px',
        backgroundColor: this.errorStyle.backgroundColor,
        color: this.errorStyle.color,
        margin: '0',
        padding: '0.5em',
        borderBottomLeftRadius: '4px',
        borderBottomRightRadius: '4px',
        fontWeight: '500'
      }
    },

    formFieldsCheckErrorStyle () {
      return {
        backgroundColor: this.errorStyle.backgroundColor,
        color: this.errorStyle.color,
        margin: '0',
        padding: '0.5em',
        borderRadius: '4px',
        fontWeight: '500'
      }
    },

    inputCustomStyles () {
      return {
        boxShadow: 'none',
        borderColor: this.errorStyle.backgroundColor
      }
    },

    isOptional () {
      return !this.parameters.required
    }
  }
}
